<template>
  <section class="apresentacao" id="apresentacao">
    <div class="conteudo">
      <h2>CLÍNICAS CERCA DE <span>SU DIRECCIÓN</span></h2>
      <div class="busca">
        <img src="@images/icone-localizacao.svg" />
        <p>{{ city }}</p>
      </div>
    </div>
    <img src="https://socheck.nyc3.cdn.digitaloceanspaces.com/imagens-white/divisor-branco.png" class="divisor" />
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const city = ref("");

onMounted(() => {
  city.value = route.query.city || "Cidade não especificada";
});
</script>

<style scoped>
section.apresentacao {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 140px 80px 120px 80px;
  position: relative;
  background-image: url("https://socheck.nyc3.cdn.digitaloceanspaces.com/imagens-white/fundo-branco.png");
  background-size: cover;
  background-position: center;
}
.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
}
h2 {
  font-family: var(--bold);
  font-size: var(--f5);
  color: var(--cor-preto);
  text-align: center;
  margin: 20px 0 10px 0;
}
h2 span {
  color: #2280b4;
}
.busca {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0 0 0;
}
p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-preto);
  text-align: center;
  line-height: 1.5;
  margin: 0 0 0 10px;
}
img.divisor {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  color: #00005b;
}

@media screen and (max-width: 1000px) {
  section.apresentacao {
    padding: 110px 20px 60px 20px;
  }
  h2 {
    font-size: var(--f4);
    width: 100%;
    max-width: 300px;
  }
  p {
    font-size: var(--f1);
  }
}
</style>
